import type { Dictionnaire } from '../type';
import { commun } from './commun';
import { temps } from './temps';
import { auth } from './auth';
import { legal } from './legal';
import { fil } from './fil';
import { sorties } from './sorties';
import { carte } from './carte';
import { lieux } from './lieux';
import { messages } from './messages';
import { appels } from './appels';
import { profil } from './profil';
import { moderation } from './moderation';
import { composants } from './composants';

export const ar: Dictionnaire = {
  commun,
  temps,
  auth,
  legal,
  fil,
  sorties,
  carte,
  lieux,
  messages,
  appels,
  profil,
  moderation,
  composants,
};
